import dayjs from 'dayjs';

export default function getTimeAgo(created_at) {
  const createdDate = dayjs(created_at, 'MM/DD/YYYY').format('MMMM D, YYYY');

  return ` ${createdDate}`;
}

// Utility function to format created_at date
export function formatCreatedAt(createdAt) {
  if (!createdAt) return 'Today'; // Default if no date exists

  if (typeof createdAt === 'string') {
    return new Date(createdAt).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  }

  if (typeof createdAt === 'object' && '_seconds' in createdAt) {
    return new Date(createdAt._seconds * 1000).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  }

  return 'Invalid Date'; // Fallback for unknown formats
}

export const getMonthsAgo = createdDate => {
  const currentDate = dayjs();
  const diffInDays = currentDate.diff(createdDate, 'day');

  return diffInDays > 0
    ? diffInDays > 365
      ? `${Math.floor(currentDate.diff(createdDate, 'year'))} year${
          currentDate.diff(createdDate, 'year') === 1 ? '' : 's'
        } ago`
      : diffInDays > 30
      ? `${Math.floor(currentDate.diff(createdDate, 'month'))} month${
          currentDate.diff(createdDate, 'month') === 1 ? '' : 's'
        } ago`
      : diffInDays === 1
      ? '1 day ago'
      : `${diffInDays} days ago`
    : 'Today';
};

// Helper function to convert Firestore timestamp to "YYYY-MM-DD" format
export function convertTimestampToYYYYMMDD(timestamp) {
  if (timestamp?._seconds) {
    // Firestore object format
    const date = new Date(timestamp?._seconds * 1000);
    return date.toISOString().split('T')[0];
  } else if (typeof timestamp === 'string') {
    // ISO 8601 string format
    return timestamp?.split('T')[0];
  }
  return null;
}
